import React from 'react';
import SummaryWidget from './SummaryWidget';
import ScoreWidget from './ScoreWidget';
import MatchingWidget from './MatchingWidget';
import { isContactAcquireur } from '../../../utils/contactProfile';

const AIWidgets = ({ formData, resume, score, hasApport, hasBudget, contactId, onRegenerateSummary }) => {
  // Score & matching biens : uniquement pour les contacts à profil acquéreur
  // (un Propriétaire peut aussi être Acquéreur — on regarde les critères réels)
  const showAcquireurWidgets = isContactAcquireur(formData);
  // lot DK5 — à la création, le résumé n'a rien à résumer : la colonne peut n'avoir plus rien
  // à afficher, auquel cas elle n'est pas rendue et le formulaire prend toute la largeur.
  const afficherResume = !!contactId;
  if (!afficherResume && !showAcquireurWidgets) return null;

  return (
    <aside className="w-full lg:w-80 lg:flex-shrink-0 space-y-4" data-testid="contact-form-colonne-ia">
      {afficherResume && (
        <SummaryWidget 
          resume={resume} 
          contactId={contactId}
          onRegenerate={onRegenerateSummary}
        />
      )}
      {showAcquireurWidgets && (
        <>
          <ScoreWidget score={score} hasApport={hasApport} hasBudget={hasBudget} />
          <MatchingWidget contactId={contactId} recherches={formData.recherches} />
        </>
      )}
    </aside>
  );
};

export default AIWidgets;
